import React from 'react';
import { Link } from 'react-router-dom';

const LinkImage = ({ alt = '', url = '', src }) => {
    if (url.startsWith('/')) {
        return (
            <Link to={url}>
                <img src={src} alt={alt} />
            </Link>
        );
    }

    return (
        <a href={url} target="_blank" rel="noreferrer">
            <img src={src} alt={alt} />
        </a>
    );
};

export default LinkImage;
